import classNames from 'classnames';
import styles from './Grid.module.scss';

export interface GridProps {
	wrap?: boolean;
	container?: boolean;
	nogutter?: boolean;
	center?: boolean;
	full?: boolean;
	rowGap?: boolean;
	children?: React.ReactNode;
}

export const UI_Grid = ({ wrap, container, nogutter, center, full, children, rowGap }: GridProps) => (
	<div
		className={classNames(
			styles.Grid,
			{ [styles.Grid___wrap]: wrap },
			{ [styles.Grid___container]: container },
			{ [styles.Grid___noGutter]: nogutter },
			{ [styles.Grid___center]: center },
			{ [styles.Grid___full]: full },
			{ [styles.Grid___rowGap]: rowGap },
		)}
	>
		{children}
	</div>
);
